export const styles = () => ({
  minHeight: '100vh',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  '.DnkKeyIcon-root': {
    boxShadow: '0px 2px 4px 0px rgba(27, 28, 29, 0.04)',
  },
});
